import { Document } from 'react-pdf';
import { styled } from '@mui/material';

import { mainPreviewContainerStyles } from '~/styles/common';

export const StyledContainer = styled('div')({
  ...mainPreviewContainerStyles,
  alignItems: 'baseline',
  // margin: '12px',
  // width: '100%',
  // height: 'calc(100% - 23px)',
});

export const StyledLoadingContainer = styled('div')({
  display: 'flex',
  flex: 1,
  minHeight: '100%',
  flexDirection: 'column',
  background: 'white',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledDocument = styled(Document)({
  minWidth: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: 6,
  paddingBlock: 0,
  background: 'darkgray',
  overscrollBehavior: 'contain',
  '& .react-pdf__message--loading': {
    display: 'flex',
    flex: 1,
  },
});
